import React from 'react';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import SquareListElem from 'components/Components/Includes/SquareListElem';
import { roomUrl } from 'utils/routing-helper';
import { get, isEmpty } from 'lodash';
import getFinalAttribute from 'utils/alternative-attribute';

function RoomsSection({
    destinationSlug, parentDestinationSlug, regionSlug, onClickQuote, hotel, title,
})
{
    return (
        <section id="rooms" className="tw-pt-10 lg:tw-pt-20 tw-px-4">
            <Fade bottom>
                <h2 className="font-arapey tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 leading-12 tw-text-center">{title}</h2>
            </Fade>

            <div className="tw-flex tw-flex-wrap tw-justify-center tw-mt-16 lg:tw-mt-16">
                {hotel.hotelRooms.map(room => (
                    <SquareListElem
                        onClickQuote={onClickQuote({ room, hotel })}
                        callToActionButton={undefined}
                        key={room.id}
                        link={roomUrl(regionSlug, parentDestinationSlug, destinationSlug, hotel.slug, room.slug)}
                        image={(room.hotelRoomPictures && !isEmpty(room.hotelRoomPictures)) ? room.hotelRoomPictures[0].path : '/assets/placeholder/no-image.jpg'}
                        title={getFinalAttribute(room, 'name')}
                        description={getFinalAttribute(room, 'description')}
                        images={(room.hotelRoomPictures && !isEmpty(room.hotelRoomPictures)) ? room.hotelRoomPictures : []}
                    />
                ))}
            </div>
        </section>
    );
}

RoomsSection.defaultProps = {
    title: 'Room Types',
};

RoomsSection.propTypes = {
    destinationSlug: PropTypes.any,
    hotel: PropTypes.object.isRequired,
    onClickQuote: PropTypes.func.isRequired,
    parentDestinationSlug: PropTypes.any,
    regionSlug: PropTypes.string.isRequired,
    title: PropTypes.string,
};

export default RoomsSection;
